<div class="row" *ngIf="user">
	<ul>
		<div class="p-3">
			<h4>Compte</h4>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Identifiant de connexion :</span>
				<span class="col-3">{{ user.username }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">E-mail :</span>
				<span class="col-12 col-lg-3">{{ user.email }}</span>
			</div>
			<div class="row p-2" *ngIf="!isIntervenant">
				<span class="col-12 col-lg-3 fw-bold">Rôle :</span>
				<span class="col-12 col-lg-3">{{ user.profile?.name }}</span>
			</div>
		</div>

		<div class="p-3">
			<h4>Informations personnelles</h4>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Prénom :</span>
				<span class="col-12 col-lg-3">{{ user.firstName }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Nom :</span>
				<span class="col-12 col-lg-3">{{ user.lastName }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Adresse :</span>
				<span class="col-12 col-lg-3">{{ user.address?.label }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Date de naissance :</span>
				<span class="col-12 col-lg-3" *ngIf="user.birthDate">{{
					user.birthDate
				}}</span>
				<span class="col-12 col-lg-3" *ngIf="!user.birthDate"
					>Non spécifié(e)</span
				>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">N° téléphone :</span>
				<span class="col-12 col-lg-3" *ngIf="user.telephone">{{
					user.telephone
				}}</span>
				<span class="col-12 col-lg-3" *ngIf="!user.telephone"
					>Non spécifié(e)</span
				>
			</div>
		</div>

		<div class="p-3">
			<h4>Activité</h4>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Expertises(s)</span>
				<span class="col-12 col-lg-3" *ngIf="employee?.expertises?.length > 0">
					<span *ngFor="let exp of employee.expertises">
						{{ exp.name }} |
					</span>
				</span>
				<span class="col-12 col-lg-3" *ngIf="employee?.expertises?.length === 0"
					>Non spécifié(e)</span
				>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Type :</span>
				<span class="col-12 col-lg-3">{{
					employeeTypeString[employee?.statutInt]
				}}</span>
			</div>
			<!-- <div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Centre de service(s) :</span>
				<span class="col">{{ employee.serviceCenter.address.label }}</span>
			</div> -->
		</div>
	</ul>
</div>
